import alpha from './alpha';

/**
 * @return {Function}
 */
export default function uuid() {
  return alpha('uuid');
}
